import React from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components';
import { Divider, Affix, message, Upload, Modal } from 'antd'
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import { Text, Tag } from '../../Reusable/Text'
import Overlay from '../../Reusable/Overlay';
import AionLogo, { Image } from '../../Reusable/Image'
import { formatPhoneTextV2 } from '../../../Utils/util';
import { PaymentLinkPageLabel } from './PaymentLinkPageLabel'

import Call from '../../../Images/call-dark.svg'
import Email from '../../../Images/email-dark.svg'
import Profile from '../../../Images/profile-dark.svg'
import Payment from '../../../Images/auto-debit-payment2.svg'
import { TextButton } from '../../Reusable/Button';


const { Dragger } = Upload

export const StyledDragger = styled(Dragger)`
    .ant-upload.ant-upload-drag {
        background: #F8F8F9 !important;
        border: 1px dashed #7384AA !important;
        border-radius: 8px !important;
        max-width: 370px;
    }
`;

export const FloatingCenteredBox = styled.div`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  border-radius: var(--Radius-R16, 16px);
  background: var(--Background-Grey, #F7F7F9);

  /* Elevation/Float */
  box-shadow: 0px 0px 64px 0px rgba(172, 172, 172, 0.24);
  min-height: 780px;
  gap: 48px;
`;

export const PaymentMethodPreview = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  width: 390px;
  height: 100%;
  padding: var(--Spacing-S16, 16px);
  border-radius: var(--Radius-R8, 8px);
  background: var(--Background-White, #FFF);
`;

export const GradientBox = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: var(--Radius-R8, 8px);
  background: linear-gradient(
      105deg,
      #F7F7F9 39.85%,
      var(--Near-Black-Near-Black---0, #E6E6EC) 97.2%
    ),
    linear-gradient(
      239deg,
      #F7F7F9 25.62%,
      var(--Near-Black-Near-Black---0, #E6E6EC) 95.24%
    );
`;

export const Placeholder = styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '40px'};
  border-radius: ${({ radius }) => radius || '8px'};
  background: ${({ background }) => background || 'var(--Grey-Grey---0, #F7F7F9)'};
`;

const BusinessPreviewCard = ({
    businessName,
    description,
    feeLabel,
    contactName,
    phone,
    email,
    theme,
    aionStore,
    logoUrl,
    onBack,
}) => {

    var { business } = aionStore
    var { businessInfo } = business.businessProfile || {}
    businessInfo = businessInfo || {}
    const imageUrl = businessInfo.logoUrl

    var imgStyle = { height: 48, width: 48, objectFit: "contain", borderRadius: "5px" }

    const ImageBox = styled.div`
        width: 48px;
        height: 48px;
        border-radius: 9.6px;
        background: url(${logoUrl || imageUrl}) lightgray 50% / cover no-repeat;
        box-shadow: 0px 0px 9.6px 0px rgba(102, 102, 102, 0.08);
        `;


    return (
        <FlexColumn fullWidth fullHeight center style={{ padding: 48 }} gap="16px">
            <Flex fullWidth between centerH>
                <Text heading size="24px" weight="600">Preview</Text>

                {onBack && <TextButton text="Edit customization" weight='400' underline onClick={onBack} />}
            </Flex>
            <FloatingCenteredBox>
                <GradientBox>
                    <FlexColumn fullWidth fullHeight center gap="48px">
                        <FlexColumn start center gap="8px">
                            <ImageBox />
                            <Text heading weight='600'>{businessName}</Text>
                            <Text center width="320px">{description}</Text>
                        </FlexColumn>

                        <FlexColumn start center gap="12px">
                            <Text heading weight='600'>{feeLabel}</Text>
                            <Flex start bottom>
                                <Text bottom size="32px" weight="600" height='8px' color={theme.colors.primary2}>$1</Text>
                                <Text bottom size="20px" weight="400" height='0' color={theme.colors.primary2} style={{ marginLeft: 2 }}>.00</Text>
                            </Flex>
                        </FlexColumn>

                        <FlexColumn start center gap="12px" fullWidth>
                            <Text heading weight='600'>Contact details</Text>
                            <Flex start gap='8px' centerH>
                                <Image src={Profile} size="30px" />
                                <Text>{contactName}</Text>
                            </Flex>
                            <Flex center gap="24px" fullWidth>
                                <Flex end gap='8px' style={{ width: "50%" }} centerH>
                                    <Image src={Call} size="30px" />
                                    <Text>{formatPhoneTextV2(phone)}</Text>
                                </Flex>
                                <Flex start gap='8px' style={{ width: "50%" }} centerH>
                                    <Image src={Email} size="30px" />
                                    <Text>{email}</Text>
                                </Flex>
                            </Flex>
                        </FlexColumn>
                    </FlexColumn>


                    <PaymentMethodPreview>
                        <Overlay
                            icon={Payment}
                            message="Your customers will be able to select from payment options and verify their bank details"
                            textWidth="159px"
                        >
                            <FlexColumn start fullWidth>
                                <FlexColumn start fullHeight fullWidth gap="24px">
                                    <Placeholder width="90px" height="8px" radius="16px" background="#EBEBF0" />
                                    <Flex between fullWidth gap="16px">
                                        <FlexColumn start fullWidth gap="5px">
                                            <Placeholder width="34px" height="8px" radius="16px" background="#EBEBF0" />
                                            <Placeholder width="100%" height="8px" radius="16px" background="#EBEBF0" />
                                        </FlexColumn>
                                        <FlexColumn start fullWidth gap="5px">
                                            <Placeholder width="34px" height="8px" radius="16px" background="#EBEBF0" />
                                            <Placeholder width="100%" height="8px" radius="16px" background="#EBEBF0" />
                                        </FlexColumn>
                                    </Flex>
                                    <Placeholder width="90px" height="8px" radius="16px" background="#EBEBF0" />
                                </FlexColumn>

                                <FlexColumn start fullHeight fullWidth gap="12px" style={{ marginTop: 12 }}>
                                    <Placeholder width="296px" height="80px" radius="8px" background="#F7F7F9" />
                                    <Placeholder width="296px" height="80px" radius="8px" background="#F7F7F9" />
                                    <Placeholder width="296px" height="80px" radius="8px" background="#F7F7F9" />
                                </FlexColumn>
                            </FlexColumn>

                            <FlexColumn start fullWidth gap="5px">
                                <Placeholder width="34px" height="8px" radius="16px" background="#EBEBF0" />
                                <Placeholder width="100%" height="8px" radius="16px" background="#EBEBF0" />
                            </FlexColumn>
                        </Overlay>
                    </PaymentMethodPreview>
                </GradientBox>
            </FloatingCenteredBox>

            {/* <PaymentLinkPageLabel /> */}
        </FlexColumn>
    );
};

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        receivablesStore: state.receivablesAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(BusinessPreviewCard)))
